import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { IT_DATE_FORMAT_CLASSIC } from '@pt/pt-models';

export class TimeUtils {
  static nowNgbDateStruct(): NgbDateStruct {
    const today = new Date();
    const year = today.getFullYear();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const response: NgbDateStruct = {
      year,
      day,
      month
    };
    return response;
  }

  static isValidMinDate(timeStamp: number, minDate?: NgbDateStruct): boolean {
    if (minDate && timeStamp) {
      const min = new Date(minDate.year, minDate.month - 1, minDate.day, 0, 0, 0);
      return min.getTime() <= timeStamp;
    }
    return true;
  }

  static toStringDate(date: NgbDateStruct): string {
    const day = date.day > 9 ? date.day : '0' + date.day;
    const month = date.month > 9 ? date.month : '0' + date.month;
    const year = date.year;
    return day + '/' + month + '/' + year;
  }

  static toTimestamp(value?: string | null): number | null {
    if (value) {
      try {
        const parseDate = _stringToDateNumber(value);
        const date = new Date();
        date.setDate(parseDate.day);
        date.setMonth(parseDate.month);
        date.setFullYear(parseDate.year);
        date.setHours(0, 0, 0);
        date.setMilliseconds(0);
        return date.getTime();
      } catch (e) {
        // return Date.now();
      }
    }
    return null;
  }

  static toTimestampAt(value: string, timeMode: 'midnight' | 'beforeMidnight'): number | undefined {
    try {
      const parseDate = _stringToDateNumber(value);
      const date = new Date(parseDate.year, parseDate.month, parseDate.day);
      switch (timeMode) {
        case 'midnight':
          date.setHours(0, 0, 0);
          break;
        case 'beforeMidnight':
          date.setHours(23, 59, 59);
          break;
      }
      return date.getTime();
    } catch (e) {
      return Date.now();
    }
  }

  static getSplitDayFromToDay(splid: number): NgbDate {
    const aDate = new Date();
    aDate.setDate(aDate.getDate() + splid);
    return new NgbDate(aDate.getFullYear(), aDate.getMonth() + 1, aDate.getDate());
  }

  static getTomorrow(): NgbDate {
    return TimeUtils.getSplitDayFromToDay(1);
  }

  static getYesterday(): NgbDate {
    return TimeUtils.getSplitDayFromToDay(-1);
  }

  static toStringValue(expirationDate: number): string | null{
    if (expirationDate) {
      const datePipe: DatePipe = new DatePipe('it');
      return datePipe.transform(expirationDate, IT_DATE_FORMAT_CLASSIC); //IT_DATE_FORMAT_CLASSIC);
    }
    return null;
  }

  static transformDDMMYYYYtoYYYYMMDD(value: string): string | null {
    const r = new RegExp(/^((\d{2})\/(\d{2})\/(\d{4}))$/);
    if (r.test(value)) {
      const s = value.split('/');
      if (s.length===3) {
        return s[2]+s[1]+s[0];
      }
    }
    return null;
  }
}

function _stringToDateNumber(value: string) {
  const day = Number.parseInt(value.split('/')[0]);
  const month = Number.parseInt(value.split('/')[1]) - 1;
  const year = Number.parseInt(value.split('/')[2]);
  return { day, month, year };
}
